import React from 'react';
import { isDesktop, isIOS } from 'react-device-detect';
import html2canvas from 'html2canvas';
import { setSentryError } from './sentry';

let isBlurAttached = false;
function addOverlay() {
  const overlay = document.createElement('div') as HTMLDivElement;
  const removeOverlay = () => {
    overlay.remove();
    overlay.removeEventListener('click', removeOverlay);
    overlay.removeEventListener('touchend', removeOverlay);
  };

  overlay.style.cssText = `position:fixed;top:0;right:0;left:0;bottom:0;z-index:1000;background:transparent;`;
  overlay.addEventListener('click', removeOverlay);
  overlay.addEventListener('touchend', removeOverlay);

  document.body.appendChild(overlay);
}

export function restoringFocusDownload(url: string, filename: string) {
  const iframe = document.createElement('iframe') as HTMLIFrameElement;
  iframe.style.cssText = 'position:absolute;width:0;height:0;border:none;';
  document.body.appendChild(iframe);

  iframe.onload = () => {
    const doc = iframe.contentDocument!;
    const link = doc.createElement('a');
    link.href = url;
    link.download = filename;
    doc.body.appendChild(link);
    link.click();

    setTimeout(() => {
      URL.revokeObjectURL(url);
      iframe.remove();
    }, 500);
  };
  iframe.src = 'about:blank';

  if (isDesktop || !isIOS) {
    return;
  }

  addOverlay();
  if (!isBlurAttached) {
    window.addEventListener('blur', addOverlay);
    isBlurAttached = true;
  }
}

export const downloadGamecastScreenshot = async (fileName?: string) => {
  const videoGameCast = document.getElementById('gamecastVideoTag');

  if (!videoGameCast) {
    return;
  }

  try {
    const canvasFromh2c = await html2canvas(videoGameCast);

    const localCanvas = document.createElement('canvas');
    const width = window.innerWidth;
    const height = Math.round((window.innerWidth * 9) / 16);
    localCanvas.width = width;
    localCanvas.height = height;

    const ctx = localCanvas.getContext('2d');
    if (ctx) {
      ctx.drawImage(canvasFromh2c, 0, 0, width, height);
    }

    const img = localCanvas.toDataURL('image/png');

    restoringFocusDownload(img, fileName ? fileName : 'screenshot.png');
  } catch (e) {
    throw new Error('Taking the gamecast screenshot has failed');
  }
};

export const downloadGoldenTicket = (
  goldenTicketRef: React.MutableRefObject<any>,
) => {
  return html2canvas(goldenTicketRef.current, {
    useCORS: true,
    backgroundColor: null,
  })
    .then(function (canvasFromh2c) {
      const dataURL = canvasFromh2c.toDataURL('image/png');
      restoringFocusDownload(dataURL, 'golden-ticket.png');
    })
    .catch(() => {
      throw new Error('Taking the golden ticket screenshot has failed');
    });
};
